import {
  Button,
  Col,
  Container,
  HomeIcon,
  Row,
} from 'plataforma-fundacao-componentes';
import { languageValues } from 'utils/LanguageUtils';

export default function NotFound() {
  return (
    <Container verticalPadding>
      <Row>
        <Col centralized>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='183.168'
            height='79.003'
            viewBox='0 0 183.168 79.003'
          >
            <g transform='translate(-519.558 -405.74)'>
              <path
                d='M183.7-23.426a4.138,4.138,0,0,1,2.968,1.007,3.422,3.422,0,0,1,1.06,2.6q0,3.6-4.028,3.6h-7.95v12.3a4.332,4.332,0,0,1-1.219,3.286A4.339,4.339,0,0,1,171.4.53a4.156,4.156,0,0,1-3.074-1.166,4.443,4.443,0,0,1-1.166-3.286v-12.3H135.786a4.012,4.012,0,0,1-2.968-1.06,3.6,3.6,0,0,1-1.06-2.65,6.191,6.191,0,0,1,1.166-3.286l34.662-50.138A4.624,4.624,0,0,1,171.4-75.26a4.387,4.387,0,0,1,3.074,1.166,4.233,4.233,0,0,1,1.272,3.286v47.382Zm-42.082,0h25.546V-60.208Z'
                transform='translate(515 481)'
                fill='#3fa110'
              />
              <path
                d='M56.5-23.426a4.137,4.137,0,0,1,2.968,1.007,3.422,3.422,0,0,1,1.06,2.6q0,3.6-4.028,3.6h-7.95v12.3A4.332,4.332,0,0,1,47.329-.636,4.339,4.339,0,0,1,44.2.53,4.156,4.156,0,0,1,41.128-.636a4.443,4.443,0,0,1-1.166-3.286v-12.3H8.586a4.012,4.012,0,0,1-2.968-1.06,3.6,3.6,0,0,1-1.06-2.65,6.191,6.191,0,0,1,1.166-3.286L40.386-73.352A4.624,4.624,0,0,1,44.2-75.26a4.387,4.387,0,0,1,3.074,1.166,4.233,4.233,0,0,1,1.272,3.286v47.382Zm-42.082,0H39.962V-60.208Z'
                transform='translate(515 481)'
                fill='#3fa110'
              />
              <g
                transform='translate(574 407)'
                fill='none'
                stroke='#3fa110'
                strokeWidth='7'
              >
                <circle cx='32.5' cy='32.5' r='32.5' stroke='none' />
                <circle cx='32.5' cy='32.5' r='29' fill='none' />
              </g>
              <line
                x2='6'
                y2='6'
                transform='translate(628.5 462.5)'
                fill='none'
                stroke='#3fa110'
                strokeWidth='3'
              />
              <line
                x2='12'
                y2='12'
                transform='translate(634.5 468.5)'
                fill='none'
                stroke='#3fa110'
                strokeLinecap='round'
                strokeWidth='6'
              />
            </g>
          </svg>
        </Col>
        <Col className='title text-center' centralized>
          {languageValues.pages.notFound.title}
        </Col>
        <Col centralized>
          <Button
            onClick={() => {
              window.location.replace(window.env.fundacao);
            }}
            leftIcon={<HomeIcon />}
          >
            {languageValues.buttons.initialPage}
          </Button>
        </Col>
      </Row>
    </Container>
  );
}
